export default "__VITE_ASSET__BGhOO6Mx__"